module.exports = __webpack_public_path__ + "img/lab-3.71e64c8b.png";